import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import CreateJobInput from '../../CreateJob/CreateJobInput'
import { useDispatch } from 'react-redux'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { useEffect, useState } from 'react'
import AxiosInstance from 'utils/AxiosInstance'
import { createApplicationTodo } from 'store/Recruitment/actions'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import moment from 'moment'
import { updateApplicationTodo } from 'store/Recruitment/actions'

const priorityOptions = [
  { name: 'Low', value: 'low' },
  { name: 'Medium', value: 'medium' },
  { name: 'High', value: 'high' },
]

function CreateTodoModal({ showModal, setShowModal, todo }) {
  const dispatch = useDispatch()
  const location = useLocation()

  const [title, setTitle] = useState('')
  const [startDate, setStartDate] = useState(null)
  const [dueDate, setDueDate] = useState(null)
  const [assignedTo, setAssignedTo] = useState(null)
  const [priority, setPriority] = useState(null)
  const [description, setDescription] = useState('')

  const [admins, setAdmins] = useState([])

  useEffect(() => {
    AxiosInstance.get(`/users/admins`).then((data) => {
      setAdmins(
        data?.map((el) => {
          return { name: `${el.first_name} ${el.last_name}`, id: el.id }
        })
      )
    })
  }, [])

  useEffect(() => {
    if (todo) {
      setTitle(todo?.title)
      setDescription(todo?.description)
      setStartDate(moment(todo?.start_date).format('YYYY-MM-DD'))
      setDueDate(moment(todo?.due_date).format('YYYY-MM-DD'))
      setAssignedTo(admins?.find((admin) => admin.id === todo?.assigned_to))
      setPriority(priorityOptions?.find((el) => el.value === todo?.priority))
    }
  }, [todo, admins])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        {!todo ? 'Create Todo' : 'Edit Todo'}
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <form
          id='todo'
          onSubmit={(e) => {
            e.preventDefault()

            dispatch(setFormSubmitted(true))

            const isValid =
              title &&
              startDate &&
              dueDate &&
              assignedTo &&
              priority &&
              description

            if (!isValid) return

            const payload = {
              application_id: location?.search?.split('=')?.at(1),
              title,
              assigned_to: assignedTo?.option?.id,
              priority: priority?.option?.value,
              start_date: startDate,
              due_date: dueDate,
              description,
            }
            if (!todo) {
              dispatch(createApplicationTodo(payload))
            } else {
              dispatch(
                updateApplicationTodo(
                  todo.id,
                  location?.search?.split('=')?.at(1),
                  payload
                )
              )
            }

            setShowModal(false)
          }}
        >
          <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
            <CreateJobInput
              id='title'
              label='Title'
              placeholder='Enter Title'
              required={true}
              fullSize={true}
              defaultValue={title}
              onChange={(val) => setTitle(val)}
            />
            <CreateJobInput
              id='startDate'
              label='Start Date'
              type='date'
              required={true}
              fullSize={false}
              defaultValue={startDate}
              onChange={(val) => setStartDate(val)}
            />
            <CreateJobInput
              id='dueDate'
              label='Due Date'
              type='date'
              required={true}
              fullSize={false}
              defaultValue={dueDate}
              onChange={(val) => setDueDate(val)}
            />
            <CreateJobInput
              id='assignedTo'
              label='Assigned To'
              placeholder='Please Select'
              select={true}
              required={true}
              fullSize={false}
              selectedOptions={assignedTo}
              options={admins}
              onChange={(val) => setAssignedTo(val)}
            />
            <CreateJobInput
              id='priority'
              label='Priority'
              placeholder='Select Priority'
              options={priorityOptions}
              select={true}
              required={true}
              fullSize={false}
              selectedOptions={priority}
              onChange={(val) => setPriority(val)}
            />
            <CreateJobInput
              id='description'
              label='Description'
              placeholder='Enter Description'
              rows={3}
              required={true}
              fullSize={false}
              defaultValue={description}
              type='textarea'
              onChange={(val) => setDescription(val)}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          text={!todo ? 'Create' : 'Update'}
          form='todo'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default CreateTodoModal
